import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import SignupLoadingSpinner from './signup/SignupLoadingSpinner';

const PLATFORM_STATUSES = ['trialing', 'active'];
const BLOCKED_STATUSES = ['past_due', 'canceled', 'unpaid'];

const subscriptionStatusLabel = (status) => {
  const labels = {
    trialing: 'Trial',
    active: 'Ativa',
    pending: 'Pendente',
    past_due: 'Pagamento em atraso',
    canceled: 'Cancelada',
    unpaid: 'Não paga',
  };
  return labels[status] || status;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading || (isAuthenticated && !user)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <SignupLoadingSpinner label="A carregar sessão…" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const subStatus = user?.subscriptionStatus || 'active';

  if (subStatus === 'pending') {
    return (
      <Navigate
        to="/register/resume"
        state={{ email: user?.email }}
        replace
      />
    );
  }

  if (BLOCKED_STATUSES.includes(subStatus)) {
    return (
      <Navigate
        to="/login"
        state={{
          subscriptionBlocked: true,
          subscriptionStatus: subStatus,
        }}
        replace
      />
    );
  }

  if (!PLATFORM_STATUSES.includes(subStatus)) {
    return (
      <Navigate
        to="/login"
        state={{
          subscriptionBlocked: true,
          subscriptionStatus: subStatus,
        }}
        replace
      />
    );
  }

  return children;
};

export { subscriptionStatusLabel };
export default ProtectedRoute;
